module.exports = __webpack_public_path__ + "img/wrapperBackgroundImg.9c34f5f5.png";